<template lang="pug">
.v-auth.auth(:class="[data?.className, {'hidden': hidden}]" )
	.auth__window(v-if="data")
		.auth__modal-nav.modal-nav
			button.modal-nav__back.js-close-modal(
					type="button"
					v-if="data.backButton"
					@click="requestDataLoad")
				v-svg-icon.modal-nav__back-icon(icon="arrow-left")
			h2.modal-nav__title(v-if="data.title && data?.className === 'choice'" ) {{ data.title }}
			button.modal-nav__close.js-close-modal-gallery(type="button")
				v-svg-icon.modal-nav__close-icon(icon="close")

		.auth__body
			template(v-for="({id, mainTitle}, index) in data.tabs" :key="index")
				.auth__title(v-if="id === activeTabId")
					img.svg-icon.auth__title-icon(
							v-if="data.image"
							:src="data.image?.src"
							:alt="data.image?.alt")
					span.auth__title-text(v-if="mainTitle") {{ mainTitle }}
			v-form(:data-source="data" @update-out="dataSet" @updateTabId="updateTabId" @redirect="hidden = true")
</template>

<script>

import sourceMixin from "../components/mixins/v-mixin-source.vue";
import controller from "../scripts/controller/controller.js";

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null,
			activeTabId: null,
			hidden: false
		};
	},

	methods: {
		dataSet(data) {
			this.data = data;

			let {
				activeTabId = null,
			} = this.data;

			if(activeTabId) {
				this.activeTabId = activeTabId;
			}

		},

		updateTabId(value) {
			this.activeTabId = value;
		},

		requestDataLoad() {
			this.dataLoad({
				url: this.data.remote,
				data: {[`action`]: 'clear'},
				delay: true,
			})
		},


	}
};
</script>
